import Image from 'next/image'
import Link from 'next/link'
import { LanguageContext } from '../hook/context'
import { useContext } from 'react'
import { ExternalLink } from 'lucide-react'

const Footer = () => {
  const { t } = useContext(LanguageContext)
  return (
    <footer className='flex flex-col gap-6 border-t border-neutral-800 pt-5 pb-5 text-neutral-400'>
      <div className='items-center flex flex-col text-center sm:items-start sm:text-left'>
        <Image
          src='/logos/dcd-w-logo.svg'
          width='113'
          height='30'
          alt='DoCode Logo'
        />
        {t.footer.description}
      </div>
      <div>
        <p className='text-sm font-semibold text-neutral-300 mb-2'>
          {t.footer.otherProjects.title}
        </p>
        <ul className='flex flex-col gap-1'>
          {t.footer.otherProjects.links.map((link: { label: string; href: string }) => (
            <li key={link.href}>
              <a
                href={link.href}
                target='_blank'
                rel='noopener noreferrer'
                className='inline-flex items-center gap-1.5 text-sm hover:text-neutral-200 transition-colors'
              >
                {link.label}
                <ExternalLink size={13} className='shrink-0' />
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className='flex items-center justify-between'>
        {t.footer.copyRight}
        <div className='flex space-x-2 '>
          <Link href='https://www.instagram.com/colorwayxpress/'>
            <Image
              className='socialIcons'
              src='/assets/Brands/instagram.svg'
              width='34'
              height='34'
              alt='DoCode Logo'
            />
          </Link>
          <Link href='https://www.linkedin.com/company/docode-software/'>
            <Image
              className='socialIcons'
              src='/assets/Brands/linkedin.svg'
              width='34'
              height='34'
              alt='DoCode Logo'
            />
          </Link>
          <Link href='https://www.youtube.com/channel/UCIqvrVzg9oCufhKAmHFuT7w/videos'>
            <Image
              className='socialIcons'
              src='/assets/Brands/youtube.svg'
              width='34'
              height='34'
              alt='DoCode Logo'
            />
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
